import { configureStore } from "@reduxjs/toolkit";
import authSlice from "./auth.slice";
import reduxReload from "./reload.slice";

export const store = configureStore({
    reducer: {
        auth: authSlice,
        reduxReload: reduxReload
    }
})